 <template>
  <v-container grid-list-md class="pa-2" id="scrollcontainertop">
    <v-layout row wrap>
      <transition-group name="flip-list" tag="v-flex" style="width: 100%;">
        <v-flex
          xs12
          v-for="betrieb in sortierteBetriebeEntfernung"
          style="width: 100%;"
          :key="betrieb.id"
          :id="'betriebID' + betrieb.id"
        >
          <v-card :raised="betrieb.premium == 1"  :class="`elevation-${betrieb.id == current ? 6 : 2}`" >
            <v-card-title
              @click="breakpointTitleClick(betrieb)"
              class="mouseoverlink grey lighten-5 cardbackground py-3"
            >
              <v-layout row class="pb-0">
                <v-flex xs9 class="pb-0">
                  <h3 class="title pb-0" flat>{{ betrieb.vollername }}</h3>
                </v-flex>
                <v-flex xs3 justify-end style="text-align: right;" class="pb-0">
                  <h3 class="title">{{ betrieb.entfernung }} km</h3>
                </v-flex>
              </v-layout>
              <!--  <div class="subheading" v-if="betrieb.innung.logo"> {{ betrieb.innung.logo }}</div> -->
            </v-card-title>
            <v-card-text
              v-if="betrieb.premium === 1"
              @click="breakpointTitleClick(betrieb)"
              class="pb-0 mb-0"
            >
              <div v-if="betrieb.premium === 1">
                <span v-if="betrieb.image_logo">
                  <img :src="'/' + betrieb.image_logo" class="logoaufkarte">
                </span>
              </div>
              <p
                class="subheading mb-1"
                style="clear: both;"
              >In {{ betrieb.stadt}} {{ betrieb.stadtteil }}</p>
              <p v-if="betrieb.kurztext">{{ betrieb.kurztext }}</p>
            </v-card-text>

            <v-card-text v-if="betrieb.zertifikate.length > 0">
              <v-layout v-for="cert in betrieb.zertifikate" :key="cert.name" row>
                <v-flex xs8  align-self-center>                
                      {{ cert.name }}
                </v-flex>
                <v-flex xs4 v-if="cert.logo">
                  <v-img :src="'/' + cert.logo"  contain max-height="75"></v-img> 
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-text
              v-if="betrieb.premium === 0"
              @click="breakpointTitleClick(betrieb)"
              style=""
              class="pb-0"
            >
            <v-layout align-start justify-space-between row px-3>
            <div  class="subheading mb-2">In {{ betrieb.stadt}} {{ betrieb.stadtteil }}</div>
            
               <div v-if="betrieb.innungen">
                    <div v-if="betrieb.innungen.length > 0">
                      <v-layout wrap row>
                        <v-flex
                          xs12
                          v-for="innung in betrieb.innungen"
                          :key="innung.id"
                        >
                          <v-card flat v-if="innung">
                            <div v-if="innung.logo">
                              <v-img
                                :src="'/' + innung.logo"
                                contain
                                :alt="innung.name"
                                min-width="80px"
                                max-width="90px"
                              ></v-img>
                            </div>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </div>
                    <div v-else>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-card flat v-if="betrieb.innung">
                            <div v-if="betrieb.innung.logo">
                              <v-img
                                :src="'/' + betrieb.innung.logo"
                                contain
                                :alt="betrieb.innung.name"
                                min-width="80px"
                              ></v-img>
                            </div> 
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
            </v-layout>
             
            </v-card-text>
            <v-card-actions style="clear: both;" class="pt-0 pb-0 mb-0">
              <v-layout row wrap align-end>
                <v-flex>
                  <v-list>
                    <!-- <v-list-tile @click="" v-bind:href="'tel:' + betrieb.telefon"> -->
                    <v-list-tile v-if="betrieb.telefon" v-bind:href="'tel:' + betrieb.telefon_link">
                      <v-list-tile-action>
                        <v-icon color="primary">phone</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ betrieb.telefon }}</v-list-tile-title>
                        <v-list-tile-sub-title>Telefon</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile class="mb-0 pb-0">
                      <v-list-tile-action>
                        <listing-save :company="betrieb"></listing-save>
                      </v-list-tile-action>
                      <v-list-tile-action v-if="betrieb.connected">
                        <v-icon alt="lul" color="primary" slot="activator">check_circle</v-icon> 
                      </v-list-tile-action>
                      <v-list-tile-action v-if="betrieb.website">
                        <v-icon color="primary" slot="activator">web_asset</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-action v-if="betrieb.email">
                        <v-icon color="primary" slot="activator">mail_outline</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-flex style="text-align: right;" class="mb-3">
                  <v-btn
                    flat
                    light
                    :to="{ name: 'showCompany', params: { id: betrieb.slug }}"
                    v-if="betrieb.premium === 1"
                  >
                    <v-icon 
                      :color="betrieb.profilfarbe" 
                      left
                      v-if="betrieb.premium_freigeschaltet === 1"
                    >check_circle_outline</v-icon> 
                    BetriebsProfil</v-btn>
                  <v-btn
                    flat
                    light
                    :to="{ name: 'showCompany', params: { id: betrieb.slug }}"
                    v-if="betrieb.premium === 0"
                  >Mehr</v-btn>
                </v-flex>
              </v-layout>
              <!-- <v-layout>
                <v-flex>{{ betrieb }}</v-flex>
                </v-layout>  -->
          </v-card-actions>
          </v-card>
          <!-- Card component end -->
        </v-flex>
      </transition-group>
    </v-layout>
  </v-container>
</template>

<script>

import ListingSave from '~/components/ListingSave.vue'

// window._ = { orderBy, shuffle }
import orderBy from 'lodash/orderBy'

export default {
  components: {
    ListingSave
  },
  props: ['betriebe', 'standort', 'sort', 'current'],

  data () {
    return {
      // current: ''
    }
  },
  mounted () {},
  methods: {
    breakpointTitleClick (betrieb) {
      if (this.$vuetify.breakpoint.name === 'xs') {
        this.$router.push({ name: 'showCompany', params: { id: betrieb.slug }})
      } else {
        this.changeCurrentundPan(betrieb.geo_lat, betrieb.geo_lng, betrieb.id)
      }
    },
    changeCurrent (id) {
      this.$emit('MapSetCurrent', id)
    },

    changeCurrentundPan (GeoLat, GeoLng, $id) {
      this.$emit('MapPan', GeoLat, GeoLng, $id)
    }
  },
  computed: {
    sortierteBetriebeEntfernung: function () {
      var sortierung = this.sort
      var richtungsort = ['asc']

      if (sortierung === 'beste') {
        sortierung = ['premium', 'entfernung']
        richtungsort = ['desc', 'asc']
      }

      return orderBy(this.locationsWithDistance, sortierung, richtungsort)
    },
    locationsWithDistance () {
      return this.betriebe.map(l => {
        var ort = this.standort
        var p = 0.017453292519943295 // Math.PI / 180
        var c = Math.cos
        var a =
          0.5 -
          c((l.geo_lat - ort.lat) * p) / 2 +
          c(ort.lat * p) *
          c(l.geo_lat * p) *
          (1 - c((ort.lng - l.geo_lng) * p)) / 2
        var BetriebsEntfernung =
          Math.round(12742 * Math.asin(Math.sqrt(a)) * 100) / 100

        return {
          ...l,
          entfernung: BetriebsEntfernung
        }
      })
    }
  }
}
</script>

<style>
.flip-list-move {
  transition: transform 0.8s;
}
.logoaufkarte {
  max-width: 300px;
  height: auto;
  float: right;
  padding: 0 0 5px 20px;
  margin: 0;
}
</style>